import { NameDto } from '@/api/Common/Types'

export interface AppropriatenessTestDto {
  maxMarginallyScore: string
  id: string
  category: string
  maxFailScore: number
  maxReferredScore: number
  name: string
  subcategory: string
  tickmillCompanyId: number
  version: number
  marginallyPass: string
  maxPassScore: number
  status: NameDto<AppropriatenessTestStatus>
  dateCreated: string | Date
  dateUpdated: string | Date
}

export enum AppropriatenessTestKey {
  testType = 'name',
  category = 'category',
  subCategory = 'subcategory',
  tickmillCompany = 'tickmillCompany.name',
  dateCreated = 'dateCreated',
  dateUpdated = 'dateUpdated',
  tickmillProduct = 'tickmillProduct.name',
  affectsTestResults = 'doesAffectsTestResult',
  version = 'version',
}

export enum AppropriatenessTestFilterKey {
  name = 'Name',
  category = 'TestCategoryId',
  subCategory = 'TestSubcategoryId',
  tickmillCompany = 'TickmillCompanyId',
  dateCreated = 'DateCreated',
  tickmillProduct = 'tickmillProductId',
  affectsTestResults = 'doesAffectsTestResult',
  status = 'StatusId',
  dateUpdated = 'DateUpdated',
}

export enum AppropriatenessTestStatus {
  Draft = 1,
  Published = 2,
  Passive = 3,
}

export enum TestTypes {
  ALL = 'All',
  APPROPRIATENESS_TEST = 'Appropriateness Test',
  ECONOMIC_PROFILE = 'Economic Profile',
}
export enum TestStatusTabs {
  ACTIVE_TEST_SETS = 'active-test-sets',
  TEST_SETS = 'test-sets',
  DRAFT = 'draft',
  NEW_APP_TEST = 'new-app-test',
  NEW_ECONOMIC_PROFILE = 'new-economic-profile',
}

export const APPROPRIATENESS_TEST_VERSION_STORAGE_KEY = 'appropriateness_test_versions'
export const ECONOMIC_PROFILE_VERSION_STORAGE_KEY = 'economic_profile_versions'
